module.exports = __webpack_public_path__ + "static/media/logos2.f54976da.png";